<template>
    <div class="runtime-custom-form">
        <div class="dynamic-attr-content"
            :style="{width: $pScreen.mainW}"
            ref="dynamicAttrContent">
            <div class="custom-form-title">谢谢您的参与</div>
            <div class="custom-form-top-img"
                :style="{height: 374*$pScreen.mainP+'px'}">
                <img :style="{width: $pScreen.mainW,height: 374*$pScreen.mainP+'px'}"
                    :src="activityPictureUrl"
                    alt>
            </div>
            <div v-if="showHistory"
                class="history"
                @click="queryHistoryData">查看历史</div>
            <div v-for="(item,index) in questionAndAnswerList"
                :key="index"
                class="question-content">
                <div class="dynamic-property-form">
                    <component :attrObj="item"
                        :channelStore="item.channelStore"
                        :is="item.questionType"></component>
                </div>
            </div>
        </div>
        <selectHistoryFormDialog ref="selectHistoryFormDialog"
            @goDetail="goDetail"></selectHistoryFormDialog>
    </div>
</template>
<script>
import { directive as clickOutside } from '@/utils/component/v-click-outside-x';
import popper from '../../../../static/comjs/popper.min.js';
import single_choice from './dynamicAttr/radio';
import multiple_choice from './dynamicAttr/checkbox';
import single_text from './dynamicAttr/input';
import multiple_text from './dynamicAttr/textarea';
import attachment from './dynamicAttr/fileUpload';
import form_time from './dynamicAttr/time';
import evaluation from './dynamicAttr/score';
import address_text from './dynamicAttr/address';
import name_text from './dynamicAttr/nameText';
import phone_text from './dynamicAttr/phoneText';
import channel from './dynamicAttr/channel.vue';
import selectHistoryFormDialog from '../customForm/select-history-form-dialog.vue';
import { Toast, List, Icon } from 'vant';

export default {
  components: {
    single_choice,
    multiple_choice,
    single_text,
    multiple_text,
    attachment,
    form_time,
    evaluation,
    address_text,
    name_text,
    phone_text,
    channel,
    selectHistoryFormDialog,
    [List.name]: List,
    [Icon.name]: Icon,
    [Toast.name]: Toast,
  },
  directives: { clickOutside },
  props: {
    activityObj: Object,
  },
  data() {
    return {
      taskId: '', //任务中心 任务id
      dataList: [],
      formCustom: {},
      activityPictureUrl: '',
      activityCode: '',
      showMenu: false,
      questionList: [],
      groupNameList: [],
      ruleValidate: {},
      showHistory: false, //是否展示查看历史按钮
      connectionId: '',
      channelStore: {},
      positionInfo: {},
      questionAndAnswerList: [],
    };
  },
  watch: {
    questionList: {
      handler(newList) {
        this.questionList = newList;
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.taskId = this.$route.query.taskId;
    console.log('taskId', this.taskId);
    this.initData();
    if (this.taskId) {
      this.updateTaskStatus();
    }
    this.ruleValidate = {
      organization: [
        {
          required: true,
          message: this.$t('finance.fundAccountManage.organizationNoEmpty'),
          trigger: 'blur',
        },
      ],
      accountNo: [
        {
          required: true,
          message: this.$t('finance.fundAccountManage.accountNotEmpty'),
          trigger: 'change',
        },
      ],
    };
  },
  //初始化后调用
  mounted: function () {},
  methods: {
    //加载表单问题数据
    async initData() {
      const self = this;
      self.activityCode = (self.$route.query && self.$route.query.activityCode) || (self.activityObj && self.activityObj.activityCode) || '';
      self.$api.post({
        sc: 'mobileMarketingH5',
        url: 'questionActivity/queryMiniActivityQuestionDetail/' + self.activityCode,
        params: {},
        success: (r) => {
          const result = r.result || {};
          document.title = result.activityName;
          self.formCustom = result;
          self.showHistory = result.showHistory;
          if (result.activityPictureUrl) {
            if (result.activityPictureUrl.indexOf('{') > -1) {
              self.activityPictureUrl = self.$utils.getImageUrl(JSON.parse(result.activityPictureUrl).file);
            } else {
              self.activityPictureUrl = self.$utils.getImageUrl(result.activityPictureUrl);
            }
          }
          const questionList = Object.assign({}, result.questionList);
          for (const i in questionList) {
            questionList[i].disabled = true;
          }
          self.questionList = questionList;
          self.questionAndAnswerList = questionList;
          self.queryUserAnswer();
        },
      });
    },
    //查询已提交数据
    queryUserAnswer() {
      const  self = this;
      let connectionId = '';
      let loginType = sessionStorage.getItem('loginType');
      let crtlParams = sessionStorage.getItem('crtlParams');
      if (crtlParams) {
        crtlParams = JSON.parse(crtlParams);
        loginType = crtlParams.loginType;
        connectionId = sessionStorage.getItem('connectionId');
      }
      if (self.$route.query && self.$route.query.historyFormConnectionId) {
        connectionId = self.$route.query.historyFormConnectionId;
      }
      if (self.connectionId) {
        connectionId = self.connectionId;
      }
      const params = {
        activityCode: self.activityCode,
        loginType: loginType,
        connectionId: connectionId ? connectionId : sessionStorage.getItem('connectionId'),
        associationActivityCode: sessionStorage.getItem('associationActivityCode'),
      };
      self.$api.post({
        sc: 'mobileMarketingH5',
        url: 'questionActivity/queryUserQuestionAnswer',
        params: params,
        success: (r) => {
          console.log(r);
          const questionList = JSON.parse(JSON.stringify(self.questionList)) ;
          const answerList = r.result || [];
          const typeArr = ['single_choice', 'multiple_choice'];
          if (answerList.length > 0) {
            for (const i in questionList) {
              let hasMatch = false; // 标记是否找到对应 answer
              for (const j in answerList) {
                if (answerList[j].questionType === 'evaluation') {
                  answerList[j].answerVO.answerContent = Number(answerList[j].answerVO.answerContent);
                }
                if (questionList[i].id == answerList[j].answerVO.questionId) {
                  hasMatch = true; // 找到匹配
                  if (typeArr.indexOf(questionList[i].questionType) > -1) {
                    const arr = answerList[j].answerVO.answerContent.split(',');
                    for (const k in arr) {
                      const arr2 = arr[k].split(':');
                      const optionList = questionList[i].optionList;
                      for (const m in optionList) {
                        if (optionList[m].optionCode == arr2[0]) {
                          optionList[m]._isSelect = true;
                        }
                      }
                    }
                  } else if (questionList[i].questionType === 'attachment') {
                    // 答案和题目组装好后，图片视频题要提示更新
                    questionList[i].needUpdate = true;
                    if (answerList[j].answerVO.answerContent) {
                      const urlArr = answerList[j].answerVO.answerContent.split(',');
                      questionList[i].desc = [];
                      urlArr.forEach((element) => {
                        // element = self.$utils.getImageUrl(element);
                        questionList[i].desc.push(element);
                      });
                    }
                    answerList[j].answerVO.disabled = true;
                  } else if (questionList[i].questionType == 'channel') {
                    if (answerList[j].answerVO.answerContent) {
                      if (answerList[j].activityItemChannel) {
                        this.$set(questionList[i], 'channelName', answerList[j].activityItemChannel.channelName);
                        console.log(123, answerList[j].activityItemChannel);
                        this.$set(questionList[i], 'channelStore', {
                          channelAddress: answerList[j].activityItemChannel.channelAddress,
                          distance: answerList[j].activityItemChannel.distance,
                          workStartTime: answerList[j].activityItemChannel.workStartTime,
                          workEndTime: answerList[j].activityItemChannel.workEndTime,
                        });
                      }
                    } else {
                      this.$set(questionList[i], 'channelName', '');
                      questionList[i].channelStore = {
                        channelAddress: '',
                        distance: '',
                        workStartTime: '',
                        workEndTime: '',
                      };
                    }
                  } else {
                    questionList[i].answerContent = answerList[j].answerVO.answerContent;
                  }
                }
              }
              // 内层循环结束后，如果是 channel 类型且没有匹配到 answer，清空赋值
              if (!hasMatch && questionList[i].questionType == 'channel') {
                this.$set(questionList[i], 'channelName', '');
                questionList[i].channelStore = {
                  channelAddress: '',
                  distance: '',
                  workStartTime: '',
                  workEndTime: '',
                };
              }
            }
          }
          this.questionAndAnswerList = JSON.parse(JSON.stringify(questionList));

        },
      });
      
    },
    //任务中心 签到任务完成
    updateTaskStatus() {
      let userInfo = sessionStorage.getItem('userInfo');
      userInfo = JSON.parse(userInfo);
      const loginType = sessionStorage.getItem('loginType');
      this.$api.post({
        sc: 'member2',
        url: `memberInfoMiniManage/updTaskDone`,
        params: {
          id: this.taskId,
          uniqId: loginType == 'wechat' ? userInfo.unionid || '' : userInfo.userId || '',
          idType: loginType == 'wechat' ? '1' : '6',
        },
        success: (r) => {
          if (r.code == 200) {
            this.$utils.tips.tSuccess();
          }
        },
      });
    },
    queryHistoryData() {
      this.$refs.selectHistoryFormDialog.openModel({ activityCode: this.activityCode });
    },
    goDetail(data) {
      this.connectionId = data.connectionId;
      this.queryUserAnswer();
    },
  },
};

// var _hmt = _hmt || [];
// (function() {
//   var hm = document.createElement("script");
//   hm.src = "https://hm.baidu.com/hm.js?4d54999f2f0a38dded80d6cc71ab8123";
//   var s = document.getElementsByTagName("script")[0];
//   s.parentNode.insertBefore(hm, s);
// })();
</script>
<style lang="scss" scoped>
.runtime-custom-form .dynamic-attr-content {
  font-size: 24px;
  width: 100%;
  background-color: whitesmoke;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}
.runtime-custom-form .dynamic-attr-content .custom-form-top-img {
  margin-bottom: 10px;
}
.runtime-custom-form .dynamic-attr-content .question-content {
  width: calc(100vw - 30px);
  display: flex;
  justify-content: center;
  .dynamic-property-form {
    width: 100%;
    background-color: #ffffff;
    padding: 10px 15px;
    border-radius: 5px;
    margin-bottom: 10px;
  }
}
.is-item-required:before {
  content: '*';
  display: inline-block;
  margin-right: 4px;
  line-height: 1;
  font-family: SimSun;
  font-size: 16px;
  color: #ed3f14;
}
.radio-options-value .selected .ivu-icon {
  color: #00b1ff;
}
.history {
  position: fixed;
  top: 60px;
  right: 0;
  border: 1px solid rgba(255, 255, 255, 1);
  border-right: transparent;
  border-radius: 50px 0 0 50px;
  font-size: 12px;
  color: #ffffff;
  width: 68px;
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.i-circle,
.i-check-circle {
  width: 16px !important;
  height: 16px;
  background: url('../../../../static/runtime/images/magic/radio.png') no-repeat;
  background-size: 100%;
}
.i-check-circle {
  background-image: url('../../../../static/runtime/images/magic/radioSelected.png');
}
.i-circle:before,
.i-check-circle:before,
.i-square:before,
.i-check-square:before {
  content: ' ';
}
.i-square,
.i-check-square {
  width: 16px !important;
  height: 16px;
  background: url('../../../../static/runtime/images/magic/checkbox.png') no-repeat;
  background-size: 100%;
}
.i-check-square {
  background-image: url('../../../../static/runtime/images/magic/checkboxSelected.png');
}
.i-circle[disabled],
.i-check-circle[disabled],
.i-square[disabled],
.i-check-square[disabled] {
  opacity: 0.3;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/submittedForm.vue